import {
  NoticeVoiceType, StoreRoomSound
} from "@/common/glboalconstant";
import { LogHelper } from "@/common/LogHelper";

// const successVoice = require("@/assets/success.wav");
// const failVoice = require("@/assets/fail.wav");
// const warnVoice = require("@/assets/warning.wav");
const voices = [];

const interceptVoiceMap = {
  "-101": NoticeVoiceType.ReturnVoice,
  "-102": NoticeVoiceType.ChangeAddressVoice,
  "-103": NoticeVoiceType.InterceptDeliveryVoice,
  "-105": NoticeVoiceType.DiscardVoice,
};


export function playSuccessSound() {
    try {
        play(NoticeVoiceType.OperSuccessVoice);
    } catch (error) {
        LogHelper.Error("播放成功声音失败:" + error);
    }

}
export function playFailSound() {

    try {
        play(NoticeVoiceType.OperFailVoice);
    } catch (error) {
        LogHelper.Error("播放失败声音失败:" + error);
    }
}
export function playWarnSound() {
    try {
        play(NoticeVoiceType.WarnVoice);
    } catch (error) {
        LogHelper.Error("播放警告声音失败:" + error);
    }
}

export function playWantedPackSound(errorCode?) {
    try {
      if (voices.length == 0) {
        getVoicePath();
      }
      let voiceType = NoticeVoiceType.WantedPackVoice;
      if (errorCode && interceptVoiceMap[errorCode]) {
        const voicePath = voices.filter(element => element.NoticeVoiceType == interceptVoiceMap[errorCode]);
        if (voicePath.length) {
          voiceType = interceptVoiceMap[errorCode];
        }
      }

      play(voiceType);
    } catch (error) {
        LogHelper.Error("播放拦截件声音失败:" + error);
    }
}
export function playCuoFaSound() {
    try {
        play(NoticeVoiceType.RouteFailVoice);
    } catch (error) {
        LogHelper.Error("播放错发声音失败:" + error);
    }
}

export function playRoomSound(i) {
  try {
    debugger;
    play(i - 1 + StoreRoomSound.StroeRoom1);
  } catch (error) {
    LogHelper.Error("播放库房声音失败:" + error);
  }
}

export function playCuoZhuang() {
  try {
    debugger;
    play(StoreRoomSound.CuoZhuang);
  } catch (error) {
    LogHelper.Error("播放错装声音失败:" + error);
  }
}
const chaoZaiAudio = new Audio(require("@/assets/noYTO.wav"));//上线前替换
chaoZaiAudio.loop =false;
chaoZaiAudio.playbackRate = 1;
export function playChaoZaiSound() {
    try {
        chaoZaiAudio.play();
    } catch (error) {
        LogHelper.Error("播放超载声音失败:" + error);
    }
}

export function NoticeVoiceInit() {
    try {
        if (voices.length == 0) {
            getVoicePath();
        }
    } catch (error) {
        LogHelper.Error("加载声音路径失败:" + error);
    }

}

// function getFilePath(path: string) {
//     if (path.indexOf("\\") == -1) {
//         return path;
//     } else {
//         let pathArr = path.split("\\");
//         return pathArr[pathArr.length - 1];
//     }
// }

function getVoicePath() {
    try {
        if (typeof obj_GlobalData_Core !== "undefined") {
            let systemDataStr = obj_GlobalData_Core.getSystemConfig();
            let systemConfig = JSON.parse(systemDataStr);
            let voiceConfig = systemConfig?.NoticeVoiceConifg.NoticeVoices;

            try {
              const commonConfig = JSON.parse(obj_GlobalData_Core.getYtoCommonConfig());
              if (commonConfig.ReturnVoice) {
                voiceConfig.push({ NoticeVoicePath: commonConfig.ReturnVoice, NoticeVoice_Type: NoticeVoiceType.ReturnVoice });
              }
              if (commonConfig.ChangeAddressVoice) {
                voiceConfig.push({ NoticeVoicePath: commonConfig.ChangeAddressVoice, NoticeVoice_Type: NoticeVoiceType.ChangeAddressVoice });
              }
              if (commonConfig.InterceptDeliveryVoice) {
                voiceConfig.push({ NoticeVoicePath: commonConfig.InterceptDeliveryVoice, NoticeVoice_Type: NoticeVoiceType.InterceptDeliveryVoice });
              }
              if (commonConfig.DiscardVoice) {
                voiceConfig.push({ NoticeVoicePath: commonConfig.DiscardVoice, NoticeVoice_Type: NoticeVoiceType.DiscardVoice });
              }
            } catch (e) {
              LogHelper.Error("加载配置失败：" + e);
            }

            LogHelper.WriteLog("voiceConfig");
            LogHelper.WriteLog(JSON.stringify(voiceConfig));
            voiceConfig.forEach(element => {
                let strPath = "";
                // let noticeVoicePath = getFilePath(element.NoticeVoicePath);
                if (element.NoticeVoicePath.indexOf(":") == -1) {
                    strPath = "\\Sound\\" + element.NoticeVoicePath;
                } else {
                    strPath = element.NoticeVoicePath;
                }
                let base64 = obj_File_Core.getFile(strPath);
                let fileName = "";
                if (strPath.indexOf("\\") != -1) {
                    fileName = strPath.split("\\")[strPath.split("\\").length - 1];
                }
                else {
                    fileName = strPath;
                }
                let bytearr2 = dataURLtoFile(base64, strPath);
                let url = window.URL.createObjectURL(bytearr2);
                // LogHelper.WriteLog(url);
                voices.push({ NoticeVoiceType: element.NoticeVoice_Type, path: url });
            });

            debugger;
            //新增对应库房声音
            let roomSoundPath = "\\Sound\\";
            let strSoundPath = "";
            for(let i = StoreRoomSound.StroeRoom1;i <= StoreRoomSound.CuoZhuang; i++)
            {
              if (i == StoreRoomSound.CuoZhuang)
              {
                strSoundPath = roomSoundPath + "错装.wav";
              }
              else
              {
                strSoundPath = roomSoundPath + i % 20 + "号库.wav";
              }
              let base64 = obj_File_Core.getFile(strSoundPath);
              let fileName = "";
              if (strSoundPath.indexOf("\\") != -1) {
                fileName = strSoundPath.split("\\")[strSoundPath.split("\\").length - 1];
              }
              else {
                fileName = strSoundPath;
              }
              let bytearr2 = dataURLtoFile(base64, strSoundPath);
              let url = window.URL.createObjectURL(bytearr2);
              voices.push({NoticeVoiceType:i, path: url });
            }
            debugger;
        } else {
            LogHelper.Error("obj_GlobalData_Core 未定义，请在客户端界面中检查是否注册同名的core文件");
        }

    } catch (error) {
        LogHelper.Error("获取声音路径方法失败:" + error);
    }
}
const player = new Audio();

function play(voiceNotice) {
    try {
      debugger;
        if (voices.length == 0) {
            getVoicePath();
        }
        if (voices.length == 0) {
            LogHelper.Warn("声音路径加载不成功:请检查客户端路径配置或者检查网页资源中声音文件是否存在");
            return;
        }
        let voicePath = voices.filter(element => element.NoticeVoiceType == voiceNotice);
        let voiceAsset: string = voicePath[0].path;
        player.src = voiceAsset;
        player.play();

    } catch (error) {
        LogHelper.Error("声音提示错误:" + error);
    }

}

function dataURLtoFile(dataurl, filename) { // 生成Blob
    try {
        let bstr = atob(dataurl);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: "audio/x-wav" });
    } catch (error) {
        LogHelper.Error("生成声音blob文件失败:" + error);
    }
}
